module.exports = __webpack_public_path__ + "img/pr-14.3e077134.png";